module.exports = __webpack_public_path__ + "home/en-US/images/shortcut-pc-change-icon-925da7626282062bb253fb7640f3bc9d.png";


//////////////////
// WEBPACK FOOTER
// ./home/en-US/images/shortcut-pc-change-icon.png
// module id = l6zq
// module chunks = 0